<div id="main">

    <header class="header" [class.over]="showInfoContent">
        <div class="top-toolbar" [class.mat-elevation-z2]="settings.fixedHeader">
            <div class="fx-row fx-align-between fx-flex">
                <div class="fx-row fx-align-center" style="gap:14px;">
                    <button *ngIf="settings.menu == 'vertical'" (click)="sidenavOpen = !sidenavOpen" class="topbar-hamburger" aria-label="Menu">
                        <span class="bar"></span>
                        <span class="bar"></span>
                        <span class="bar"></span>
                    </button>
                    <h1 class="topbar-page-title">{{ pageTitle }}</h1>
                </div>
                <div class="fx-row fx-align-end">
                    <app-applications></app-applications>
                    <app-fullscreen></app-fullscreen>
                    <app-user-menu></app-user-menu>
                </div>
            </div>
        </div>
    </header>

    <div class="page-wrapper">

        <div class="sidenav mat-elevation-z6"
             *ngIf="settings.menu == 'vertical'"
             [class.sidenav-closed]="!sidenavOpen">
            <app-sidenav></app-sidenav>
        </div>

        <div class="mat-drawer-content" #mainContent (scroll)="onScroll($event)"
             [class.sidenav-open]="sidenavOpen && settings.menu == 'vertical'">
            <div class="dna-alert-region">
                <dna-alert></dna-alert>
            </div>
            <router-outlet></router-outlet>
        </div>

    </div>

    <div #backToTop class="fx-row fx-align-center back-to-top" (click)="scrollToTop()">
        <span class="material-icons">arrow_upward</span>
    </div>

</div>
